export const CURRENT_TERMS_VERSION = "2026-09-03";
export const CURRENT_PRIVACY_VERSION = "2026-09-04";

const DELETION_SAFE_SUBSCRIPTION_STATUSES = new Set(["canceled", "incomplete_expired"]);

export const canDeleteAccountForSubscription = (status: string | null): boolean =>
  status === null || DELETION_SAFE_SUBSCRIPTION_STATUSES.has(status);
